import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack } from '@bingads-webui-react/fabric-control';
import { TitleBar } from './title-bar';
import { Content } from './content';
import { Details } from './details';

export const Panel = (props) => {
  const {
    title, children, isActive, setActiveKeys, id, activeKeys, error, setActiveCallback, onFocus, disableExpand, details, noOverflowHidden,
  } = props;

  return (
    <Stack className={`${classNames('collapse-panel', id)} ${isActive ? '' : 'isCollapse'}`} tokens={{ padding: '0 24px' }} onFocus={() => onFocus()}>
      <TitleBar disableExpand={disableExpand} id={id} title={title} isActive={isActive} error={error} setActiveKeys={setActiveKeys} activeKeys={activeKeys} setActiveCallback={setActiveCallback} />
      <Content isActive={isActive} noOverflowHidden={noOverflowHidden}>{children}</Content>
      {details && <Details isActive={isActive}>{details}</Details>}
    </Stack>
  );
};

Panel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  isActive: PropTypes.bool,
  disableExpand: PropTypes.bool,
  children: PropTypes.node.isRequired,
  setActiveKeys: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.string,
  activeKeys: PropTypes.arrayOf(PropTypes.string),
  setActiveCallback: PropTypes.func,
  details: PropTypes.node,
  noOverflowHidden: PropTypes.bool,
};

Panel.defaultProps = {
  id: '',
  error: '',
  activeKeys: [],
  setActiveKeys() { },
  isActive: false,
  setActiveCallback() { },
  onFocus() { },
  disableExpand: false,
  details: null,
  noOverflowHidden: false,
};
